import { render } from "./BankAccountCard.vue?vue&type=template&id=18970fc1"
import script from "./BankAccountCard.vue?vue&type=script&lang=js"
export * from "./BankAccountCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__